<template>
  <div class="card px-5 py-8 lg:px-8">
    <div class="md:flex md:float-left">
      <h2>Overview</h2>
      <div class="flex mt-2 active-filters-parent">
        <vx-tooltip position="bottom">
          <span v-if="showFilterCounter > 0" class="active-filter-counter mt-6">
            <span>{{ appliedFiltersCount }}</span>
            {{filterCounterText}}
          </span>

          <template slot="html">

            <div class="tooltip-parent">
              <h6 class="tooltip-h6">Filters</h6>
              <div class="flex" v-for="(filterValue, filterName) in filtersTooltip" :key="filterName" >
                <h6 class="tooltip-title">{{ filterName == 'Events' ? 'Conversions' : filterName }}: </h6>
                <span class="tootltip-data">{{ normalizeToolTipFilter(filterValue) }}</span>
              </div>
            </div>
          </template>
        </vx-tooltip>

        <div id="home-clear-filters-button" v-if="showFilterCounter > 0" class="clear-filters-parent" @click="removeFilters">
          <span class="clear-filters">Clear</span>
          <span class="">
            <vs-icon class="clear-icon" icon="speakol-cancel" icon-pack="speakol"></vs-icon>
          </span>
        </div>
      </div>
    </div>

    <!-- test -->
    <div class="md:float-right buttons-parent">
      <speakol-date-range-picker
        id="home-date-range-picker-input"
        v-on:date-change="setDateFilter"
        class="home-date-range-picker"
        :dateRange="dateRange"
        :minimumDate="minDate"
        @click.native="$gtag.event('Filter_Date')"
        @input="emitFilter()"
        :ignoreDefault="true">
      </speakol-date-range-picker>

      <button id="home-all-filters-button" class="shadow-none speakol-all-filters-button" @click="showHomeAllFilters = !showHomeAllFilters">
        <vs-icon class="speakol-filters" icon="speakol-filters" icon-pack="speakol"></vs-icon>
        <span class="all-filters-span">
          {{ $t('All Filters') }}
        </span>
      </button>

      <div v-show="showHomeAllFilters" id="filters-container" class="filters-container">
        <speakol-checkbox-tree
          class="mb-6"
          v-if="$hasAnyFeature('sub-accounts') && allAccounts.length > 1"
          :fetchFunction="loadSubAccounts"
          id="home-sub-accounts-filter-input"
          ref="accounts-tree"
          @input="setSelectedAccountsIds"
          :includeAll="true" placeholder="All Sub Accounts">
        </speakol-checkbox-tree>

        <speakol-checkbox-tree
          ref="campaigns-tree"
          class="mb-6"
          @input="setSelectedCampaignsId"
          :fetchFunction="loadCampaignsIds"
          id="home-all-Campaigns-filter-input"
          placeholder="All Campaigns">
        </speakol-checkbox-tree>

        <v-select
          :clearable="false"
          class="mb-12"
          id="home-event-filter-input"
          v-model="filterQuery.action_type"
          @input="setSelectedActionType"
          :options="pixelEvents"
          :placeholder="$t('Choose an event')" :dir="$vs.rtl ? 'rtl' : 'ltr'" />


        <button @click="$gtag.event('Apply_filter')" id="home-filter-button" class="mb-4 speakol-filter-button w-full" v-on:click="emitFilter">{{ $t('Filter') }}</button>
        <button id="home-cancel-button" @click="closeFilters" class="speakol-cancel-button w-full">{{ $t('Cancel') }}</button>
      </div>

    </div>
    <!-- test -->

    <div class="w-full flex flex-wrap justify-between">

      <!-- Impressions -->
      <speakol-analytics-card :title="cards.impressions | addComma" subTitle="Impressions" icon="speakol-eye"
        backgroundColor="#DFF2FA" color="#0092D7" class="sub-card mb-4 lg:mr-14 lg:sub-card"
        tooltip="This indicates the number of times users have seen your ads. Every time your ads are displayed, it counts as one impression.">
      </speakol-analytics-card>

      <speakol-analytics-card :title="cards.clicks | addComma" subTitle="Clicks" icon="speakol-finger-click"
        backgroundColor="#FFF3E8" color="#FF9F43" class="sub-card mb-4 lg:mr-14 lg:sub-card"
        tooltip="This indicates the total number of user clicks that your campaign ads have received.">
      </speakol-analytics-card>

      <speakol-analytics-card :title="cards.ctr | addComma('%')" subTitle="CTR" icon="speakol-percentage-sign"
        backgroundColor="#EEF8F7" color="#6EC8BA" class="sub-card mb-4 lg:mr-14 lg:sub-card"
        tooltip="Clicks through Rate determines the percentage of user clicks that your campaign ads have received. You can calculate your CTR by dividing the number of user clicks by the number of impressions.">
      </speakol-analytics-card>

      <speakol-analytics-card :title="cards.average_cpc | addComma('$')" subTitle="Avg. CPC" icon="speakol-us-dollar"
        backgroundColor="#F5ECE5" color="#AB6226" class="sub-card mb-4  lg:sub-card"
        tooltip="This indicates the average amount of money charged per campaign ad click. You can calculate your Avg. CPC by dividing the total cost of clicks by the total number of clicks.">
      </speakol-analytics-card>

      <speakol-analytics-card :title="cards.video_views | addComma" subTitle="Video Views" icon="speakol-start"
        backgroundColor="#FBE5E5" color="#DB2828" class="sub-card mb-4  lg:sub-card"
        tooltip="This indicates the number of videos a user watches after he/she clicks on your campaign ad.">
      </speakol-analytics-card>

      <speakol-analytics-card :title="cards.spent | addComma('$')" subTitle="Spent" icon="speakol-us-dollar"
        backgroundColor="#FDF9EE" color="#F0C970" class="sub-card mb-4 lg:sub-card"
        tooltip="This indicates the total budget spent on ad campaigns over a selected period.">
      </speakol-analytics-card>

      <speakol-analytics-card :title="cards.events_numbers | addComma" :subTitle="cards.event_name == 'Events' ? 'Conversions' : cards.event_name"
        icon="speakol-user-account" backgroundColor="#F5FAEE" color="#AAD575" class="sub-card mb-4 lg:mb-0 lg:sub-card"
        tooltip="This indicates the total number of users who took action on your landing pages.">
      </speakol-analytics-card>

      <speakol-analytics-card :title="cards.cpa | addComma('$')" subTitle="CPA" icon="speakol-us-dollar"
        backgroundColor="#F3EAFB" color="#9B51E0" class="sub-card mb-4 lg:sub-card"
        tooltip="This indicates the amount of money charged when users become customers by completing an action on your landing page.">
      </speakol-analytics-card>

    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import accountsTree from '@/helpers/accountsTree'
import {reduce, extend, cloneDeep, has, first, includes, truncate, isArray, remove} from 'lodash'

export default {
  data () {
    return {
      filterQuery: {
        'campaigns-ids': [],
        'action_type': {
          id: 'total',
          label: 'Conversions'
        }
      },
      dateRange: {
        startDate: this.calculateStartDate(),
        endDate: new Date()
      },
      minDate: this.calculateMinDate(),
      firstLoad: true,

      allCampaigns: [],
      allAccounts: [],
      searchAccountsIds: null,

      showHomeAllFilters: false,
      showFilterCounter: false,

      appliedFilters: [],
      filtersTooltip: {}

    }
  },
  props: {
    'cards': {
      'default' () {
        return {}
      }
    }
  },
  computed: {

    ...mapGetters({
      pixelEvents: 'campaign/pixelEvents'
    }),

    filterCounterText () {
      if (this.appliedFiltersCount > 1) {
        return 'Active Filters'
      } else {
        return 'Active Filters'
      }
    }

  },


  async created () {
    await this.loadSubAccounts()
  },

  async mounted () {
    // this.windowClick()
    window.addEventListener('click', this.windowClick)
  },

  beforeDestroy () {
    window.removeEventListener('click', this.windowClick)
  },

  methods: {
    // Filters Code //
    showAppliedFilter () {
      this.appliedFiltersCount = this.appliedFilters.length || 0
      this.showFilterCounter = this.appliedFiltersCount > 0
      this.filtersTooltip = reduce(this.appliedFilters, (previous, current) => {
        return extend(cloneDeep(previous), cloneDeep(current))
      }, {})
    },

    resolveCampaignsIds (campaignsIds) {
      if (has(campaignsIds, -1)) {
        return ['All']
      }
      return campaignsIds.map((campaignId) => {
        return first(this.allCampaigns.filter(loadedCampaign => loadedCampaign.id === campaignId)).name
      })
    },

    resolveAccountsIds (accountsIds) {
      if (includes(accountsIds, -1)) {
        return ['All']
      }
      return accountsIds.map((accountId) => {
        return first(this.allAccounts.filter(loadedAccount => loadedAccount.id === accountId)).name
      })
    },

    normalizeToolTipFilter (toolTipFilers) {
      const firstFilterName = truncate(first(toolTipFilers), { length: 8 })
      if (isArray(toolTipFilers)) {
        if (toolTipFilers.length > 1) {
          return `${firstFilterName}+${toolTipFilers.length - 1}`
        } else {
          return firstFilterName
        }
      } else {
        return toolTipFilers
      }
    },

    removeFilters () {
      if (this.$hasAnyFeature('sub-accounts') && this.allAccounts.length > 1) {
        this.$refs['accounts-tree'].setDefault()
      }
      this.$refs['campaigns-tree'].setDefault()
      this.filterQuery.action_type = {
        id: 'total',
        label: 'Conversions'
      }
      this.appliedFilters = []
      this.filterQuery = {
        'from-date': this.filterQuery['from-date'],
        'to-date': this.filterQuery['to-date'],
        'action_type': {
          id: 'total',
          label: 'Conversions'
        },
        'campaigns-ids' : []
      };
      this.searchAccountsIds = null
      this.emitFilter()
    },

    addToAppliedFilters (filter) {
      const filterName = first(Object.keys(filter))
      if (filterName) {
        this.removeFromAppliedFilters(filterName)
        this.appliedFilters.push(filter)
      }
    },

    removeFromAppliedFilters (filterName) {
      remove(this.appliedFilters, (filter) => {
        return filterName === first(Object.keys(filter))
      })
    },


    windowClick (e) {
      const filters_container = document.getElementById('filters-container')
      if (!filters_container) return
      const all_filters_button = document.getElementById('home-all-filters-button')
      if (!all_filters_button) return
      if (!filters_container.contains(e.target) && !all_filters_button.contains(e.target) && e.target.nodeName !== 'BODY') {
        this.showHomeAllFilters = false
      }
    },
    closeFilters () {
      this.showHomeAllFilters = false
    },
    calculateStartDate () {
      const accountCreatedAt = new this.$moment(this.$store.getters['authentication/activeAccount'].created_at)
      const sevenDaysAgo = this.$moment().subtract(7, 'days')
      const startDate = accountCreatedAt.isAfter(sevenDaysAgo) ? accountCreatedAt : sevenDaysAgo
      return startDate.format('YYYY-MM-DD')
    },

    calculateMinDate () {
      return new Date(new this.$moment(this.$store.getters['authentication/activeAccount'].created_at).subtract(1,
        'days'))
    },
    setSelectedActionType (actionType) {
      if (actionType && actionType.id === 'total') {
        this.removeFromAppliedFilters('Events')
      } else {
        this.addToAppliedFilters({ Events: actionType.label })
      }
      this.$gtag.event('Filter_Events')
    },
    async setSelectedAccountsIds (accountsIds) {
      this.filterQuery['campaigns-ids'] = null


      if (accountsIds.length === 0) {
        this.removeFromAppliedFilters('Accounts')
        this.searchAccountsIds = await accountsTree.mapAccountsToIds()
      } else {
        this.addToAppliedFilters({ 'Accounts': this.resolveAccountsIds(accountsIds) })
        this.searchAccountsIds = accountsIds
      }

      this.filterQuery['accounts-ids'] = accountsIds
      await this.loadCampaignsIds(this.searchAccountsIds)

      this.$refs['campaigns-tree'].setDefault()
      this.$refs['campaigns-tree'].loadOptions()
      this.$gtag.event('Filter_Subaccounts')
    },

    setSelectedCampaignsId (campaignsIds) {
      this.filterQuery['campaigns-ids'] = campaignsIds
      if (campaignsIds.length === 0) {
        this.removeFromAppliedFilters('Campaigns')
      } else {
        this.addToAppliedFilters({ 'Campaigns': this.resolveCampaignsIds(campaignsIds) })
      }
      this.$gtag.event('Filter_Campaigns')
    },

    async loadSubAccounts () {
      this.allAccounts = await accountsTree.loadSubAccounts()

      return accountsTree.maptToTree(this.allAccounts)
    },

    async loadCampaignsIds () {

      let campaigns = []

      if (this.firstLoad || !this.searchAccountsIds) {
        campaigns = this.allCampaigns = await this.getCampaigns()

        this.firstLoad = false
      } else if (this.searchAccountsIds && this.searchAccountsIds.length > 0) {
        campaigns = this.loadCampaignsOfAccounts(this.searchAccountsIds)
      }

      this.showHomeAllFilters = true

      return campaigns.map((obj) => {
        return {
          id: obj.id,
          label: obj.name
        }
      })
    },

    loadCampaignsOfAccounts (accountsIds) {
      return this.allCampaigns.filter(campaign => {
        return accountsIds.indexOf(campaign.account_id) !== -1
      })
    },

    async getCampaigns () {
      const {
        data: response
      } = await window.axios.get('/campaigns/get-user-account-campaigns-without-full-details', {
        params: {
          include_children: true
        }
      })
      if (response.success) {
        return response.payload
      }
      return []
    },
    async searchCampaigns (searchWord) {
      const {data: response} = await window.axios.get('/campaigns/search-account-campaigns', {
        params: {
          accounts_ids: this.searchAccountsIds || [],
          search_word: searchWord,
          include_children: 1
        },
        hideLoader: true
      })
      if (response.success) {
        return response.payload
      }
    },
    setDateFilter (date) {
      this.filterQuery['from-date'] = this.$moment(date.startDate).format('YYYY-MM-DD')
      this.filterQuery['to-date'] = this.$moment(date.endDate).format('YYYY-MM-DD')
    },
    async emitFilter () {
      let campaignsIds = this.filterQuery['campaigns-ids']

      if (this.searchAccountsIds && (!campaignsIds || campaignsIds.length === 0)) {
        // All Accounts In Drop Down Menu

        let accountsIds = this.searchAccountsIds

        if (!accountsIds) {
          accountsIds = await accountsTree.mapAccountsToIds()
        }

        campaignsIds = this.loadCampaignsOfAccounts(accountsIds).map(el => {
          return el.id
        })
      }
      this.filterQuery['campaigns-ids'] = campaignsIds

      this.$emit('filter', this.filterQuery)
      this.showHomeAllFilters = false
      this.showAppliedFilter()
    }
  }
}

</script>

<style lang="scss" scoped>

  .buttons-parent {
    display: flex;
  }

  .speakol-all-filters-button {
    background-color: white;
    color: #0092d7;
    border: 1px solid #0092d7;
    border-radius: 3px;
    padding: 7px 0 7px 25px;
    width: 135px;
    cursor: pointer;
    height: 40px;
    position: relative;
    margin-left: 10px;
  }

  .speakol-filters {
    color: #0092d7 !important;
    position: absolute;
    margin-left: -30px;
    margin-top: -2px;
    font-size: 20px !important;
  }

  .filters-container {
    background-color: white;
    border: 1px solid #dedede;
    border-radius: 5px;
    max-width: 360px;
    width: 100%;
    position: absolute;
    margin-left: 45px;
    z-index: 1;
    padding: 29px;
    margin-top: 56px;
  }

  .speakol-filter-button {
    background-color: #0092d7;
    color: white;
    border-radius: 3px;
    padding: 7px 20px;
    border: 1px solid #0092d7;
    cursor: pointer;
    height: 40px;
  }

  .speakol-cancel-button {
    background-color: white;
    color: #2c2c2c;
    border: 1px solid #d9d9d9;
    border-radius: 3px;
    padding: 7px 20px;
    width: 135px;
    cursor: pointer;
    height: 40px;
  }

  .home-date-range-picker {
    width: 260px !important;
  }

  .tooltip-parent {
    margin-left: 10px;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .active-filter-counter {
    color: rgba(44, 44, 44, 0.56);
  }

  .tooltip-h6 {
    color: white;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 12px;
    margin-top: 10px;
  }

  .tooltip-title {
    color: white;
    font-weight: 200;
    line-height: 21px;
  }

  .tootltip-data {
    font-weight: 500;
    font-size: 14px;
    margin-left: 5px;
  }

  .clear-filters-parent {
    cursor: pointer;

    .clear-filters {
      color: #0092d7;
      font-weight: 600;
      font-size: 14px;
      margin-left: 8px;
    }

    .clear-icon {
      color: #0092d7;
      margin-left: 8px;
      font-size: 13px !important;
      position: relative;
      top: 1px;
    }
  }

  .active-filters-parent {
    margin-left: 20px;
  }

  .sub-card {
    @apply w-full;
  }

  @media (min-width: 768px) {
    .lg\:sub-card {
      width: calc(25% - 16px);
      margin-bottom: 25px !important;
    }
  }

  @media (max-width: 768px) {
    .buttons-parent {
      display: block;
    }

    .sub-card {
      margin-top: 20px;
    }

    .all-filters-li,
    .speakol-all-filters-button,
    .export-li-mobile-version,
    .speakol-table-export-button,
    .date-picker-li,
    .speakol-date-range-picker {
      width: 100% !important;
    }

    .speakol-all-filters-button {
      margin-left: 0;
      margin-right: 0;
      margin-top: 20px;
    }

    .active-filters-parent {
      margin-left: 0;
      margin-bottom: 0 !important;
      margin-top: 10px !important;
    }

    .bindingFiltersContainer {
      top: 301px;
    }

    .filtersParentInCaseZeroBalance {
      top: 395px;
    }

    .filtersParentinCaseCounter {
      top: 267px;
    }

    .filtersParentinCaseCounter {
      top: 301px;
    }

    /deep/ .vue-treeselect__multi-value-label {
      max-width: 130px !important;
    }
  }

  @media (max-width: 576px) {
    .whitespace-no-wrap {
      color: #cfcfcf;
      margin-right: 10px;
    }

    .reportrange-text {
      border: 1px solid #cfcfcf;
    }

    .home-date-range-picker {
      margin-top: 10px;
    }
  }

  @media (max-width: 414px) {
    .filters-container {
      margin-top: 10px;
      width: 347px;
      right: 34px;
    }
  }

  @media (max-width: 375px) {
    .filters-container {
      width: 307px;
    }
  }

  @media (max-width: 320px) {
    .filters-container {
      width: 252px;
    }

    .filtersParentinCaseCounter {
      top: 301px;
    }
  }
</style>
